<template>
  <div class="w-full h-full cursor-pointer bg-white flex flex-col rounded-lg overflow-hidden">
    <div class="rounded-t-lg relative w-full !h-48 overflow-hidden bg-white">
      <img
        v-if="detail?.thumbnail"
        :src="detail.thumbnail"
        class="absolute inset-0 w-full h-full object-fill"
        alt="business-account-banner"
        loading="lazy"
        decoding="async"
      />

      <span
        v-if="detail?.has_video"
        class="absolute top-2 left-2 z-10 w-9 h-9 rounded-full bg-white flex items-center justify-center"
      >
        <IconPlayRegular class="w-4 h-4 text-black" />
      </span>
    </div>
    <div
      class="w-full h-max flex flex-col justify-start items-center bg-white rounded-b-lg flex-1"
      :class="{ 'bg-gradient-to-br from-[#ECECFE] to-[#D3D5FD]': detail?.is_vip }"
    >
      <div class="-mt-3.5 self-end mr-5 z-20 relative">
        <VueStarRating
          :rounded-corners="true"
          :star-size="15"
          active-color="#ffb300"
          inactive-color="#f2f2f2"
          :border-width="3"
          border-color="#ffb300"
          :show-rating="false"
          :read-only="true"
          :increment="0.5"
          :rating="detail?.rating"
        ></VueStarRating>
      </div>
      <div class="p-3 w-full min-w-0">
        <p
          class="text-start w-full text-main-color font-bold text-xl truncate"
          :title="detail?.name"
        >
          {{ detail?.name }}
        </p>

        <p class="text-start w-full text-[#333333] font-light truncate" :title="detail?.caption">
          {{ detail?.caption }}
        </p>

        <div class="flex items-center gap-1 mt-2 min-w-0" v-if="detail?.work_hours">
          <IconClock class="shrink-0" />
          <span class="min-w-0 truncate" :title="detail?.work_hours[getDay.toLowerCase()]">
            {{ detail?.work_hours[getDay.toLowerCase()] }}
          </span>
        </div>

        <div class="flex items-center gap-1 mt-2 min-w-0">
          <IconMarker class="shrink-0" />
          <span class="min-w-0 truncate" :title="detail?.location">
            {{ detail?.location }}
          </span>
        </div>
      </div>
      <div class="mt-auto w-full">
        <div v-if="!detail?.is_vip && detail?.subscription == ''" class="py-5"></div>
        <div
          v-if="detail?.is_vip"
          class="w-max ml-auto px-3 bg-[#7951F9] text-white font-bold text-2xl text-end"
        >
          VIP
        </div>
        <button
          v-if="detail?.subscription !== ''"
          class="w-full rounded-b-md py-3 font-bold"
          :class="getSubcriptionType?.color"
        >
          {{ getSubcriptionType?.name }}
        </button>
      </div>
      <!-- <span v-else>&emsp;</span> -->
    </div>
  </div>
</template>

<script>
import IconClock from '@icons/IconClock.vue';
import VueStarRating from 'vue-star-rating';
import IconMarker from '@icons/IconMarker.vue';
import IconPlayRegular from '@icons/IconPlayRegular.vue';

export default {
  name: 'BusinessAccountCard',
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },
  components: {
    VueStarRating,
    IconClock,
    IconMarker,
    IconPlayRegular,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
  computed: {
    getSubcriptionType() {
      switch (this.detail.subscription) {
        case 'Gold':
          return { color: 'bg-[#FABB18] text-black', name: 'Gold' };
        case 'Silver':
          return { color: 'bg-[#C0C0C0] text-black', name: 'Silver' };
        case 'Bronze':
          return { color: 'bg-[#AE7145] text-white', name: 'Bronze' };
        default:
          break;
      }
    },
    getDay() {
      if (this.detail?.work_hours) {
        let date = new Date();
        return date.toLocaleString('en-us', { weekday: 'long' });
      }
      return null;
    },
  },
  created() {},
};
</script>
